var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtherscan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5074_10759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4377 28.482C12.4378 28.148 12.5038 27.8173 12.632 27.5089C12.7602 27.2004 12.9481 26.9204 13.1849 26.6848C13.4217 26.4492 13.7026 26.2626 14.0116 26.1359C14.3207 26.0092 14.6517 25.9448 14.9857 25.9463L19.2103 25.9601C19.8839 25.9601 20.5298 26.2276 21.0061 26.7039C21.4824 27.1802 21.75 27.8262 21.75 28.4997V44.4735C22.2256 44.3324 22.8364 44.1819 23.5048 44.0245C23.969 43.9155 24.3828 43.6527 24.6789 43.2789C24.975 42.9051 25.1362 42.4422 25.1361 41.9653V22.1505C25.1361 21.4769 25.4036 20.8309 25.8799 20.3546C26.3561 19.8782 27.0021 19.6105 27.6757 19.6104H31.9087C32.5823 19.6105 33.2282 19.8782 33.7045 20.3546C34.1808 20.8309 34.4484 21.4769 34.4484 22.1505V40.5406C34.4484 40.5406 35.5082 40.1117 36.5405 39.676C36.924 39.5138 37.2512 39.2423 37.4814 38.8954C37.7116 38.5484 37.8345 38.1413 37.8349 37.725V15.8014C37.8349 15.1279 38.1024 14.482 38.5786 14.0057C39.0547 13.5294 39.7006 13.2618 40.3741 13.2617H44.607C45.2806 13.2617 45.9266 13.5293 46.4029 14.0055C46.8791 14.4818 47.1467 15.1278 47.1467 15.8014V33.855C50.8166 31.1953 54.5356 27.9966 57.4869 24.1502C57.9152 23.5919 58.1985 22.9364 58.3116 22.2419C58.4248 21.5475 58.3643 20.8359 58.1356 20.1705C56.7693 16.24 54.598 12.6378 51.7598 9.59466C48.9216 6.55148 45.4795 4.1343 41.6535 2.49781C37.8276 0.861327 33.7021 0.0415603 29.5412 0.0909754C25.3802 0.140391 21.2755 1.0579 17.4895 2.78479C13.7035 4.51167 10.3197 7.00989 7.55464 10.1196C4.78958 13.2293 2.70414 16.882 1.43179 20.844C0.159446 24.8059 -0.271794 28.9898 0.165665 33.128C0.603123 37.2662 1.89965 41.2675 3.97228 44.8758C4.33333 45.4982 4.86451 46.0047 5.50343 46.3358C6.14233 46.6668 6.86243 46.8086 7.57918 46.7446C8.37984 46.6743 9.37672 46.5745 10.562 46.4353C11.0779 46.3767 11.5543 46.1304 11.9003 45.7432C12.2463 45.356 12.4378 44.8551 12.4382 44.3358L12.4377 28.482Z",
    fill: "url(#paint0_linear_5074_10759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3457 54.1026C16.8075 57.3485 22.0804 59.297 27.5808 59.7323C33.0814 60.167 38.595 59.0723 43.5118 56.568C48.4285 54.0638 52.5565 50.2483 55.4394 45.5437C58.3219 40.8389 59.847 35.4284 59.8455 29.9107C59.8455 29.2222 59.8135 28.541 59.7678 27.8638C48.8404 44.1611 28.6642 51.7803 12.3466 54.1001",
    fill: "url(#paint1_linear_5074_10759)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5074_10759",
    x1: 12.7678,
    y1: 0.0888654,
    x2: 45.4802,
    y2: 26.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9EC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB10D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5074_10759",
    x1: 22.7363,
    y1: 27.8638,
    x2: 45.5892,
    y2: 50.0437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#936707"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5074_10759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherscan);
export default __webpack_public_path__ + "static/media/etherscan.b2fc65fe092f0ad17acc6ddac8cfd497.svg";
export { ForwardRef as ReactComponent };